import { styles, mobileStyles } from "./../Style.js";
import { SetCard } from "./SetCard"
import { getMatch, getText, getDeck } from "./SetCalc.js";
import {useEffect, useState} from "react";

export function SetBoard(props) {
    const boardPositions = [
        [0, 1, 2, 3, 4],
        [5, 6, 7, 8, 9],
        [10,11,12,13,14],
        [15,16,17,18,19]
    ]

    return (
        <div style={props.isMobile ? {...styles.CardGroup, ...mobileStyles.CardGroup} : styles.CardGroup}>
            {boardPositions.map((row) => (
                <div style={styles.CardRow} >
                    {row.map((pos) => (
                        <SetCard n={props.board[pos]} pos={pos} key={pos} handleClick={props.click} selected={(() => {
                            for (let i = 0; i < 3; i ++) {
                                if (props.selected[i] == pos) {
                                    return "yes"
                                }
                            }
                            return "no"
                        })()} />
                    ))}
                </div>
            ))}
        </div>
    )
}
